<template>
    <modal-gdb :ref="modal_code"
        :code="modal_code"
        :dialog-width="$vuetify.display.mdAndUp? '50%': '100%'"
        toolbar-title="Competência"
        @on-toggle="onToggleModal">
        <template v-slot:activate-slot>
            <slot name="modal-activate"></slot>
        </template>
        <template v-slot:body>
            <div>
                <label for="form_nome">Nome da Competência: </label>
                <!-- eslint-disable-next-line -->
                <v-text-field class="pt-1" v-model="competencia.nome" 
                    id="form_nome"
                    placeholder="Nome da competência..."
                    ></v-text-field>
            </div>
            <div>
                <label for="form_descricao">Descrição: </label>
                <!-- eslint-disable-next-line -->
                <v-text-field class="pt-1" v-model="competencia.descricao"
                    placeholder="descrição"
                    id="form_descricao"></v-text-field>
            </div>
            <v-btn color="success" @click="saveCompetencia(competencia)" class="mr-1">Salvar</v-btn>
            <v-btn color="error" v-if="competencia.id" @click="deleteCompetencia(competencia)">Remover</v-btn>
        </template>
    </modal-gdb>
</template>
<script>
import CompetenciaFormValidation from '@/validations/forms/rh/formCompetencia'
const validacaoCompetencia = new CompetenciaFormValidation()
export default {
    name: 'FormCompetenciaComponent',
    props: {
        competencia: {
            required:true
        }
    },
    data: () => ({
        modal_code: 'modal_rh_form_competencia',
    }),
    methods: {
        onToggleModal(value){
            this.$emit('toggled-form', value)
        },
        closeFormModal(){
            this.$refs[this.modal_code].dialog = false
        },
        closeAndRefresh(){
            this.closeFormModal()
        },
        validateForm(competencia){
            const valida = validacaoCompetencia.validate(competencia)
            return valida
        },
        saveCompetencia(competencia){
            if (!this.validateForm(competencia)) return
            if (!competencia.id){
                this.createCompetencia(competencia)
            } else {
                this.updateCompetencia(competencia)
            }
        },
        async createCompetencia(){
            const created = await this.$store.dispatch('CreateRHCompetencia', this.competencia)
            if (created){
                this.$emit('on-created', true)
                this.closeFormModal()
            }
        },
        async updateCompetencia(){
            const updated = await this.$store.dispatch('UpdateRHCompetencia', this.competencia)
            if (updated){
                this.$emit('on-updated', true)
                this.closeFormModal()
            }
        },
        async deleteCompetencia(){
            const conf = confirm('Tem certeza que deseja remover a competência: "'+this.competencia.nome+'"?')
            if (!conf) return
            const deleted = await this.$store.dispatch('DeleteRHCompetencia', this.competencia)
            if (deleted){
                this.$emit('on-deleted', true)
                this.closeFormModal()
            }
        },
    },
    mounted() {
    },
    watch: {
        // propObject:{
        //     handler(value){
        //         const prop = value
        //         this.competencia = prop
        //     }, deep: true
        // }
    }
}
</script>